module.exports = "/assets/dist/images/carvana-logo.svg?c94b8c0ceea750a0bc5c95dbe25cacf9";